<template>
  <v-menu v-model="isOpen" :close-on-content-click="false">
    <template v-slot:activator="{ props }">
      <v-btn
        v-if="hasLogs"
        icon
        size="x-small"
        class="d-inline-block"
        v-bind="props"
        title="View Mutation History"
        :badge="logCount"
        variant="text"
      >
        <v-icon>mdi-history</v-icon>
      </v-btn>
    </template>
    <MutationLogs
      :record_id="recordId"
      :itemKey="itemKey"
      :mutation_logs_count="databaseLogCount"
    />
  </v-menu>
</template>

<script>
import MutationLogs from '@/components/MutationLogs.vue'

export default {
  name: 'MutationLogsButton',
  components: {
    MutationLogs
  },
  props: {
    recordId: {
      type: Number,
      required: true
    },
    itemKey: {
      type: String,
      required: true
    },
    databaseLogCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  computed: {
    logCount() {
      return this.databaseLogCount || 0
    },
    hasLogs() {
      return this.databaseLogCount > 0
    }
  }
}
</script>
